exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".descriptionContainer[data-v-ba3448a4]{width:100%;margin-bottom:2em}.descriptionContainer h2[data-v-ba3448a4]{padding-top:.75em;padding-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba3448a4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/util/OverviewDescription.vue
// module id = 437
// module chunks = 0